import BasicCrudService from "./BasicCrudService";
const crudService = new BasicCrudService();
export default crudService;